<template lang="pug">
  .app-calendar-header
    .header-left
      slot(name="header-left")
    .header-center.is-flex.is-centered
      span.prev-month.title.is-4(@click.stop="goPrev") {{ leftArrow }}
      span.title.is-uppercase {{ title }}
      span.next-month.title.is-4(@click.stop="goNext") {{ rightArrow }}
    .header-right
      slot(name="header-right")
</template>

<script>
import moment from 'moment';

export default {
  props: {
    currentMonth: {
      type: Object,
      default: () => ({}),
    },
    firstDay: {
      type: Number,
      default: 0,
    },
    locale: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      leftArrow: '<',
      rightArrow: '>',
    };
  },
  computed: {
    title() {
      if (!this.currentMonth) return '';

      return this.currentMonth.locale(this.locale).format('MMMM YYYY');
    },
  },
  methods: {
    goPrev() {
      const newMonth = moment(this.currentMonth).subtract(1, 'months').startOf('month');

      this.$emit('change', newMonth);
    },
    goNext() {
      const newMonth = moment(this.currentMonth).add(1, 'months').startOf('month');

      this.$emit('change', newMonth);
    },
  },
};
</script>

<style lang="stylus" scoped>
.app-calendar-header
  display flex
  align-items center

.header-center.is-flex.is-centered
  flex-direction row

.header-left
.header-right
  flex 1

.header-center
  flex 3
  text-align center

.title
  margin 0 .25rem

.prev-month
.next-month
  cursor pointer
</style>
